import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { NUMBER } from "../libs/utils";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";

import {
  sendOtpMerge,
  accountMerge,
  resendOtpMerge,
  resetAccountMerge,
} from "../redux/slices/accountMergeSlice";
import {
  resetMobileMsgId,
  resetEmailMsgId,
} from "../redux/slices/accountMergeSlice";
import { getUserToken } from "../libs/user";
import CustomPopupBox from "./CustomPopupBox";
import successLogo from "../assets/img/successLogo.svg";

const VerifyDetails = () => {
  const [mobileOtp, setMobileOtp] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [otpErr, setOtpErr] = useState("");
  const [resendOtpErr, setResendOtpErr] = useState("");
  const [counter, setCounter] = useState("");
  const [sendOtpSuccess, setSendOtpSuccess] = useState(false);
  const [mergeUsersSuccess, setMergeUsersSuccess] = useState(false);
  const email_otp_message_id = useSelector(
    (state) =>
      state.accountMerge.verifyOtpMergeSevice?.data?.email_otp_message_id
  );
  const mobile_otp_message_id = useSelector(
    (state) =>
      state.accountMerge.verifyOtpMergeSevice?.data?.mobile_otp_message_id
  );

  const account_merge = useSelector((state) => state.accountMerge);
  const location = useLocation();
  const { mobileInput, email } = location.state;

  const authToken = getUserToken();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setMobileOtp(value);
    }
  };

  const handleEmailOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setEmailOtp(value);
    }
  };
  const isValidForm = () => {
    if (!mobileOtp || mobileOtp.length !== 6) {
      return false;
    }
    if (!emailOtp || emailOtp.length !== 6) {
      return false;
    }
    return true;
  };

  const handleKeyUp = (e) => {
    if (mobileOtp.length === 6 || mobileOtp.length === 6) {
      e?.target?.blur();
    }
  };

  const handleEmailKeyUp = (e) => {
    if (emailOtp.length === 6 || emailOtp.length === 6) {
      e?.target?.blur();
    }
  };

  const handleVerifyDetails = () => {
    if (isValidForm()) {
      dispatch(
        accountMerge({
          email,
          mobile_otp_message_id: mobile_otp_message_id,
          email_otp_message_id: email_otp_message_id,
          mobile_otp: mobileOtp,
          email_otp: emailOtp,
          token: authToken,
        })
      )
        .unwrap()
        .then((res) => {
          setMergeUsersSuccess(true);
          console.log(res);
        })
        .catch((error) => {
          setMergeUsersSuccess(false);
          console.log(error);
        });
    }
  };

  const handleResendOTP = () => {
    const input = ("+1" + mobileInput).replace(/[- )(]/g, "");
    setSendOtpSuccess(false);
    setOtpErr("");
    setMobileOtp("");
    setEmailOtp("");
    dispatch(
      resendOtpMerge({
        mobile_otp_message_id,
        email_otp_message_id,
        token: authToken,
      })
    )
      .unwrap()
      .then((response) => {
        setResendOtpErr("");
        setSendOtpSuccess(true);
      })
      .catch((error) => {
        setSendOtpSuccess(false);
        setResendOtpErr(error.response?.data?.error?.message);
        console.log(error);
      });
  };

  useEffect(() => {
    if (sendOtpSuccess) {
      setCounter(60);
    }
  }, [sendOtpSuccess]);

  useEffect(() => {
    setCounter(60);
    return () => {
      setResendOtpErr("");
      setOtpErr("");
      dispatch(resetMobileMsgId());
      dispatch(resetEmailMsgId());
      dispatch(resetAccountMerge());
    };
  }, []);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const handleAction = () => {
    setMergeUsersSuccess(false);
    navigate("/plaid", { replace: true });
  };

  return (
    <div>
      <div className="containtLndPg verify-details-container ">
        {/* login content starts*/}
        <div className="center-container">
          <div className="center-container-box container1">
            <h2 className={`verifyHeader`}>Verify your details</h2>
            <div className={`detailsTextContainer`}>
              <span className={`codeText`}>
                We sent a 6 digit code to both your email and phone number.
              </span>
            </div>
            <div className="login-form login">
              <form onSubmit={handleSubmit(handleVerifyDetails)}>
                <div className="field-box">
                  <div className={`mobileOtpText`}>
                    <span>Enter the OTP sent to {email}</span>
                  </div>

                  <div onKeyUp={handleEmailKeyUp} className={`otpInput`}>
                    <OTPInput
                      shouldAutoFocus={true}
                      numInputs={6}
                      value={emailOtp}
                      onChange={handleEmailOtpChange}
                      inputStyle={`input_style`}
                      className={`formGroupOtp`}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <div className={`mobileOtpText`}>
                    <span>Enter the OTP sent to {mobileInput}</span>
                  </div>
                  <div onKeyUp={handleKeyUp} className={`otpInput`}>
                    <OTPInput
                      shouldAutoFocus={true}
                      numInputs={6}
                      value={mobileOtp}
                      onChange={handleOtpChange}
                      inputStyle={`input_style`}
                      className={`formGroupOtp`}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <span className="errMsg">{otpErr}</span>
                  {resendOtpErr && (
                    <span className="errMsg">{resendOtpErr}</span>
                  )}
                </div>

                {account_merge.list?.error && (
                  <span className="errMsg">
                    {account_merge.list?.error?.response?.data?.error?.message}
                  </span>
                )}

                <button
                  onClick={() => handleVerifyDetails()}
                  className={isValidForm() ? `btnGolden` : `btnGray`}
                  style={{
                    padding: "10px 61px",
                    width: "100%",
                    cursor: "pointer",
                  }}
                  type="button"
                  disabled={!isValidForm()}
                >
                  Verify both Details
                </button>

                {sendOtpSuccess && counter !== 0 && (
                  <div className={`resendContainer`}>
                    <span className={`resendOTPtext`}>New Code Sent!</span>
                  </div>
                )}
                {counter !== 0 ? (
                  <div className="mobileInputText">{`Resend code in ${counter}s`}</div>
                ) : (
                  <div className={`sendCode`}>
                    <a onClick={handleResendOTP}> {"Send Code Again ->"}</a>
                  </div>
                )}
              </form>
              {mergeUsersSuccess && (
                <CustomPopupBox
                  imgSrc={successLogo}
                  imgClass="logoImg"
                  heading={"Success!"}
                  headingClass="accountHeader"
                  descrText1={`${email} and  +${mobileInput}`}
                  descrText2="are now verified and linked."
                  descrClass="descrText"
                  btnTxt1={"Continue"}
                  handleAction={() => handleAction()}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyDetails;
